<div class="app-panel setup-container">
  <!-- First row: Top buttons -->
  <div class="top-buttons">
    <form [formGroup]="controlsFormData" *ngIf="controlsFormData">
      <button mat-stroked-button (click)="openConfigDialog()">
        <mat-icon>settings</mat-icon>
        Broadcast config
      </button>
      <button mat-stroked-button (click)="openLowerThirdDialog()">
        <mat-icon>person</mat-icon>
        Lower third
      </button>
      <button mat-stroked-button (click)="openCustomTableDialog()">
        <mat-icon>table</mat-icon>
        Custom table
      </button>
      <button mat-stroked-button (click)="openManualLineupsDialog()">
        <mat-icon>people</mat-icon>
        Manual lineups
      </button>
      <button mat-stroked-button (click)="openRosterDialog()">
        <mat-icon>groups</mat-icon>
        Edit roster
      </button>
      <button mat-stroked-button [cdkCopyToClipboard]="getControlUrl()">
        <mat-icon>content_copy</mat-icon>
        Copy manual control URL
      </button>
      Last update time: {{game?.lastUpdate?.toDate() | date :'yyyy-mm-dd HH:MM:ss'}}
      <button mat-stroked-button (click)="forceGameUpdate()" *ngIf="isAdmin()">
        <mat-icon>refresh</mat-icon>
        Refresh game
      </button>
    </form>
  </div>

  <!-- Second row: 4 columns layout -->
  <div class="second-row">
    <!-- Column 1: Preview -->
    <div class="preview-column">
      <div class="preview">
        <div class="scale-down" [ngClass]="skinCssClass">
          <app-followed-games [broadcast]="broadcast" [game]="game" controlAction="on"></app-followed-games>
          <app-status [broadcast]="broadcast" [game]="game" controlAction="on"></app-status>
          <app-status [broadcast]="broadcast" [game]="game" manual='true' controlAction="on"></app-status>
          <app-pitcher [broadcast]="broadcast" [game]="game" controlAction="on"></app-pitcher>
          <app-batter [broadcast]="broadcast" [player]="game?.currentBatter" controlAction="on"></app-batter>
          <app-lower-third [broadcast]="broadcast" controlAction="on"></app-lower-third>
          <app-custom-table [broadcast]="broadcast" controlAction="on"></app-custom-table>
          <app-box-score [broadcast]="broadcast" [game]="game" controlAction="on"></app-box-score>
        </div>
      </div>
    </div>

    <!-- Column 2: Visiting team lineup buttons -->
    <div class="visiting-team-column">
      <div>{{broadcast?.config?.awayConfig?.shortName}}</div>
      <div class="team-buttons">
        <div class="button-container" *ngIf="game?.away?.lineup || (broadcast?.config?.useManualLineups && broadcast?.manualLineups?.awayLineup?.length > 0)">
          <mat-grid-list cols="1" rowHeight="40" *ngFor="let player of getCurrentLineup(true)">
            <mat-grid-tile>
              <button class="select-button"
                      mat-stroked-button
                      [class.selected]="broadcast?.lowerThird?.guid === player?.guid"
                      [class.current]="player?.guid === game?.currentBatter?.guid"
                      (click)="selectPerson(player)">
                {{utilService.getNumber(player, broadcast)}} {{utilService.getName(player, broadcast).split(' ')[0].toUpperCase()}}
              </button>
            </mat-grid-tile>
          </mat-grid-list>
        </div>
      </div>
    </div>

    <!-- Column 3: Home team lineup buttons -->
    <div class="home-team-column">
      <div>{{broadcast?.config?.homeConfig?.shortName}}</div>
      <div class="team-buttons">
        <div class="button-container" *ngIf="game?.home?.lineup || (broadcast?.config?.useManualLineups && broadcast?.manualLineups?.homeLineup?.length > 0)">
          <mat-grid-list cols="1" rowHeight="40" *ngFor="let player of getCurrentLineup(false)">
            <mat-grid-tile>
              <button class="select-button"
                      mat-stroked-button
                      [class.selected]="broadcast?.lowerThird?.guid === player?.guid"
                      [class.current]="player?.guid === game?.currentBatter?.guid"
                      (click)="selectPerson(player)">
                {{utilService.getNumber(player, broadcast)}} {{utilService.getName(player, broadcast).split(' ')[0].toUpperCase()}}
              </button>
            </mat-grid-tile>
          </mat-grid-list>
        </div>
      </div>
    </div>

    <!-- Column 4: Broadcast layer component -->
    <div class="broadcast-layer-column" [class.linked-output]="isLinkedToCurrentUser">
      <app-broadcast-layer [isSetup]="true"></app-broadcast-layer>
    </div>
  </div>

  <!-- Third row: Control buttons -->
  <div class="controls">
    <div>
      <ng-container *ngFor="let control of controls$ | async; let idx = index; trackBy: trackByComponent">
        <div class="control-tab" *ngIf="control.component != 'poweredBy'"
             [class.active]="control.action === 'on'"
             (click)="toggleControl(control)">
          <div class="title">{{ getComponentTitle(control.component) }}</div>
          <mat-icon class="toggler">{{ control.action === 'on' ? 'toggle_on' : 'toggle_off'}}</mat-icon>
          <mat-icon class="icon">{{ getComponentIcon(control.component) }}</mat-icon>
        </div>
      </ng-container>
    </div>
  </div>
</div>
